/**
 * Customers View Component - Extracted from CRMTab
 * Handles customer listing, approval, and CRUD operations
 */
import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { Plus, Pencil, Trash2 } from 'lucide-react';

export const CustomersView = ({
  customers,
  openCustomerDialog,
  handleDeleteCustomer,
  handleApproveCustomer,
  language,
  t,
}) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <p className="text-slate-500 font-medium">{customers.length} {t.customers}</p>
        <Button onClick={() => openCustomerDialog()} className="bg-emerald-600 hover:bg-emerald-700 text-white shadow-md">
          <Plus className="h-4 w-4 mr-2" />
          {t.newCustomer}
        </Button>
      </div>

      <Card className="shadow-md border-slate-200">
        <CardContent className="p-0 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50">
                <TableHead>{t.customerNumber}</TableHead>
                <TableHead>{t.name}</TableHead>
                <TableHead>{t.email}</TableHead>
                <TableHead>{t.phone}</TableHead>
                <TableHead>{t.company}</TableHead>
                <TableHead>CIF/NIF</TableHead>
                <TableHead>{language === 'es' ? 'Estado' : 'Status'}</TableHead>
                <TableHead className="text-right">{t.actions}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {customers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} className="text-center py-8 text-muted-foreground">
                    {t.noCustomers}
                  </TableCell>
                </TableRow>
              ) : (
                customers.map((customer) => (
                  <TableRow 
                    key={customer.id} 
                    className={`hover:bg-slate-50/50 ${!customer.is_active && customer.password_hash ? 'bg-amber-50' : ''}`}
                  >
                    <TableCell className="font-bold text-emerald-600">#{customer.customer_number}</TableCell>
                    <TableCell className="font-medium">{customer.name}</TableCell>
                    <TableCell>{customer.email}</TableCell>
                    <TableCell>{customer.phone}</TableCell>
                    <TableCell>{customer.company}</TableCell>
                    <TableCell>{customer.nif || '-'}</TableCell>
                    <TableCell>
                      {customer.password_hash ? (
                        customer.is_active ? (
                          <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                            {language === 'es' ? 'Activo' : 'Active'}
                          </span>
                        ) : (
                          <Button 
                            size="sm" 
                            variant="outline"
                            onClick={() => handleApproveCustomer(customer.id)}
                            className="text-amber-600 border-amber-300 hover:bg-amber-50 hover:text-amber-700 text-xs"
                          >
                            {language === 'es' ? 'Aprobar' : 'Approve'}
                          </Button>
                        )
                      ) : (
                        <span className="px-2 py-1 bg-slate-100 text-slate-500 rounded-full text-xs font-medium">
                          {language === 'es' ? 'Sin cuenta' : 'No account'}
                        </span>
                      )}
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex items-center justify-end gap-1">
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          onClick={() => openCustomerDialog(customer)} 
                          className="text-slate-600 hover:text-emerald-600 hover:bg-emerald-50"
                        >
                          <Pencil className="h-4 w-4" />
                        </Button>
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          onClick={() => handleDeleteCustomer(customer.id)} 
                          className="text-slate-400 hover:text-rose-600 hover:bg-rose-50"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  );
};

export default CustomersView;
